import App from '@/models/App'

export default class SelectShipCountry extends App {
    static get entity() {
        return 'SelectShipCountrys'
    }
    static all() {
        return this.query().get()
    }
    static findByCode(code) {
        return this.query().where('value', code).first()
    }
    static fields() {
        return {
            id: this.attr(''),
            value: this.attr(''),
            ja: this.attr(''),
            en: this.attr(''),
        }
    }
    static apiConfig = {
        actions: {
            fetch(page) {
                return this.get(`/env/select/ship/country`, {
                    params: {},
                    headers: {
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
        },
    }
}
